import { create } from "zustand";
import { find } from "../../services/service";
export const useStorePointService = create((set) => ({
  loading: false,
  data: [],
  getData: async (url) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: false,
        data: [],
      });
    }
  },
}));
